export const en = {
    close: 'Close',
};
